export interface EbookListingMeta {
  id: string;
  title: string;
  slug: string;
  description: string;
  topics: string[];
  status: 'published' | 'coming-soon';
}

export const EBOOK_LISTINGS: EbookListingMeta[] = [
  {
    id: 'ebook-rewards-system',
    title: 'Rewards Store Guide',
    slug: 'rewards-store-guide',
    description:
      'Set up a store students love and staff can actually manage. Learn best practices for pricing, inventory, and running successful redemption events.',
    topics: [
      'Setting up your store',
      'Pricing strategies',
      'Managing inventory',
      'Running store events',
      'Student engagement tips',
    ],
    status: 'published',
  },
  {
    id: 'ebook-house-points',
    title: 'House Points Guide',
    slug: 'house-points-guide',
    description:
      'Build school spirit with team-based competitions. This guide covers everything from creating houses to running competitions that motivate every student.',
    topics: [
      'Creating house identities',
      'Point structures',
      'Competition ideas',
      'Inclusive participation',
      'Celebrating wins',
    ],
    status: 'coming-soon',
  },
  {
    id: 'ebook-digitizing-pbis',
    title: 'Digitizing PBIS Guide',
    slug: 'digitizing-pbis-guide',
    description:
      'Move from paper to digital without losing what works. A step-by-step guide for schools transitioning their PBIS implementation to LiveSchool.',
    topics: [
      'Mapping your matrix',
      'Training staff',
      'Student rollout',
      'Family communication',
      'Measuring success',
    ],
    status: 'coming-soon',
  },
];
